import { render, staticRenderFns } from "./buyModal.vue?vue&type=template&id=6ee55232"
import script from "./buyModal.vue?vue&type=script&lang=js"
export * from "./buyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports